<template>
    <div>
    
        <div class="p-relative" v-if="dataSource">
            
            <div class="top-btns-bar">
                <div class="transparent-buttons">
                    <v-btn
                        @click="ok"
                        small
                        tile
                        text
                        :disabled="isPending || (!isPeriodSelected && periodicity > 0) || !isDataChanged"
                    >
                        <v-popover :trigger="'hover'">
                            <v-icon left>
                                far fa-save
                            </v-icon>
                            <template>
                                {{ $t('Сохранить') }}
                            </template>

                            <template slot="popover">
                                <template>
                                    <span class="ribbon-button-submenu-title">{{ $t('Сохранить_изменения') }}</span>
                                </template>
                            </template>
                        </v-popover>
                    </v-btn>

                    <v-btn
                        v-if="(isPeriodSelected || periodicity == 0) && allowExport"
                        @click="exportClassifier"
                        small
                        tile
                        text
                    >
                        <v-popover :trigger="'hover'">
                            <v-icon left>
                                far fa-file-export
                            </v-icon>
                            <template>
                                {{ $t('Экспорт') }}
                            </template>

                            <template slot="popover">
                                <template>
                                    <span class="ribbon-button-submenu-title">{{ $t('Экспортировать_данные') }}</span>
                                </template>
                            </template>
                        </v-popover>
                    </v-btn>

                    <v-btn
                        v-if="isPeriodSelected || periodicity == 0"
                        @click="importClassifier"
                        small
                        tile
                        text
                        :disabled="isPending"
                    >
                        <v-popover :trigger="'hover'">
                            <v-icon left>
                                far fa-file-import
                            </v-icon>
                            <template>
                                {{ $t('Импорт') }}
                            </template>

                            <template slot="popover">
                                <template>
                                    <span class="ribbon-button-submenu-title">{{ $t('Импортировать_данные') }}</span>
                                </template>
                            </template>
                        </v-popover>
                    </v-btn>

                </div>
            </div>

            <v-form class="wrapperForm" ref="form" lazy-validation>
                <v-row dense>
                    <v-col cols="12" sm="12" md="12" class="section-wrapper">
                        <v-card flat>
                            <v-card-text>
                                <div class="form-box-title title-with-right-part">
                                    <span>{{title}}</span>
                                    <!-- v-model="periodObject" -->
                                        <period-selector 
                                            v-if="periodicity > 0"
                                            :periodicity="periodicity"                                            
                                            :period.sync="periodValue"
                                            :year.sync="periodYear"
                                            :date.sync="periodDate"
                                        />
                                        <!--<v-menu 
                                            v-model="dateMenuVisible"
                                            :close-on-content-click="false"
                                            :nudge-right="40"
                                            transition="scale-transition"
                                            offset-y
                                            min-width="290"
                                        >
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-chip 
                                                    class="table-label"
                                                    small
                                                    label
                                                    color="teal"
                                                    dark
                                                    v-bind="attrs"
                                                    v-on="on"
                                                >
                                                    <div class="d-flex align-center">
                                                        <v-icon>far fa-calendar-alt</v-icon>
                                                        <template v-if="dataDate == null">
                                                            {{ $t("Дата") }}
                                                        </template>
                                                        <template v-else>
                                                            {{ dataDate | formattedDate }}
                                                        </template>
                                                    </div>
                                                </v-chip>
                                            </template>

                                            <v-date-picker 
                                                v-model="dataDate"
                                                @input="handle"
                                                color="teal"
                                                :first-day-of-week="1"
                                            >
                                            </v-date-picker>
                                        </v-menu>-->
                                    
                                </div>
                                
                                <v-progress-linear 
                                    v-if="isPending" 
                                    slot="progress" 
                                    height="2" 
                                    color="#E43958" 
                                    indeterminate
                                ></v-progress-linear>

                                <v-simple-table 
                                    class="customization-list-table bordered-table table-with-sticky-header"
                                    v-if="isPeriodSelected || periodicity == 0"
                                    :key="dataKey"
                                >
                                    <template v-slot:default>
                                        <thead>                                                            
                                            <tr 
                                                v-for="(trdata, trKey) in getHeadTRData()" 
                                                :key="'tr'+trKey"
                                            >

                                                <th 
                                                    v-for="(thdata, thKey) in [...trdata, {action: true}]" 
                                                    :key="'tr'+trKey+'th'+thKey"
                                                    :rowspan="thdata.rowspan"
                                                    :colspan="thdata.colspan"
                                                >
                                                    <template v-if="thdata.action">
                                                        <v-btn 
                                                            color="cyan" 
                                                            text
                                                            depressed 
                                                            @click="addRow" 
                                                        >
                                                            {{$t("Добавить")}}
                                                        </v-btn>
                                                    </template>
                                                    <template v-else>
                                                        {{ localized(thdata.title) }}
                                                    </template>
                                                </th>                                                
                                            </tr>
                                        </thead>
                                        <tbody :key="tbodykey">
                                            <tr 
                                                v-for="(trdata, trKey) in dataSource.rows" 
                                                :key="'tr'+trKey"
                                            >
                                                <td
                                                    v-for="(tddata, tdKey) in [...trdata.data, {action: true}]"
                                                    :key="'tr'+trKey+'td'+tdKey"
                                                >
                                                    <template v-if="!!getDataType(tdKey) && !trdata.readonly">
                                                        <v-text-field                                                            
                                                            :key="'t'+trKey+'d'+tdKey"    
                                                            hide-details                                                                        
                                                            dense
                                                            :type="getDataType(tdKey)"                                                            
                                                            min="0"
                                                            :value="tddata"
                                                            @input="e => {                                                                         
                                                                updateDataSource({ property: `rows[${trKey}].data[${tdKey}]`, value: getValue(tdKey, e)}); 
                                                                updateCalculatedCells();
                                                            }"
                                                            @keypress="blockMinus"
                                                            @paste="blockPasteWithMinus"
                                                        >
                                                        </v-text-field>
                                                    </template> 
                                                    <template v-else-if="tddata.action">
                                                        <button> - </button>
                                                    </template>
                                                    <template v-else>
                                                        <CalculatedCell 
                                                            v-if=" typeof tddata === 'string' && tddata.startsWith('this.')" 
                                                            ref="calculatedCells"
                                                            :formula="tddata"
                                                            :row-index="trKey"
                                                            :col-index="tdKey"
                                                            :calculate-function="calculate"   
                                                            :calculation-trigger="calculatedCellTrigger"                                                             
                                                        />
                                                        
                                                        <span v-else> {{ localized(tddata) }} </span>
                                                    </template>
                                                </td>
                                            </tr>                                                         
                                        </tbody>
                                    </template>  
                                </v-simple-table>
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>
            </v-form>

        </div>
        <ImportClassifierDlg ref="importClassifierDlg"/>
    </div>
</template>

<script>
// import _ from "lodash";
import { mapActions, mapGetters } from 'vuex';
import CalculatedCell from '../../components/card/CalculatedCell.vue';
import PeriodSelector from '../../components/sep/PeriodSelector.vue';
import ImportClassifierDlg from '../../components/sep/dialogs/ImportClassifierDlg.vue';
import sys from '@/services/system';

export default {
    name: "DynamicTableView",
    components: {
        CalculatedCell,
        PeriodSelector,
        ImportClassifierDlg
    },
    
    data () {
        return {
            sectionModel: null,
            tbodykey: 0,
            focusedInput: null,
            calculatedCellTrigger: 0,
            dateMenuVisible: false,
            // periodObject: null
        }
    },
    filters: {
        formattedDate: function (value) {
            return sys.dateFormat(value, 'DD.MM.YYYY') ?? "";
        }
    },
    computed: {
        ...mapGetters('sep/dynamictableaddrows', {
            isPending: 'isPending', 
            dataSource: 'dataSource', 
            periodicity: 'getPeriodicity', 
            dataKey: 'getDataKey',
            isDataChanged: 'isDataChanged',
            allowImport: 'getAllowImport'
        }),
        title() {            
            return this.localized(this.dataSource.title);
        },
        // debug 
        // periodicity() {
        //     return 7;
        // },
        periodDate: {
            get () {
                return this.$store.getters[`sep/dynamictableaddrows/getPeriodDate`];
            },
            set (newValue) {    
                this.$store.commit(`sep/dynamictableaddrows/SET_PERIOD_DATE`, newValue);
                this.$store.dispatch(`sep/dynamictableaddrows/getData`);
            }
        },
        periodYear: {
            get () {
                return this.$store.getters[`sep/dynamictableaddrows/getPeriodYear`];
            },
            set (newValue) {    
                this.$store.commit(`sep/dynamictableaddrows/SET_PERIOD_YEAR`, newValue);
                this.$store.dispatch(`sep/dynamictableaddrows/getData`);
            }
        },
        periodValue: {
            get () {
                return this.$store.getters[`sep/dynamictableaddrows/getPeriodValue`];
            },
            set (newValue) {    
                this.$store.commit(`sep/dynamictableaddrows/SET_PERIOD_VALUE`, newValue);
                this.$store.dispatch(`sep/dynamictableaddrows/getData`);
            }
        },
        allowExport(){
            return true;// !this.allowImport;
        },
        isPeriodSelected() {

            switch(this.periodicity) {
                case 1: 
                    return !!this.periodValue;

                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                    return !!this.periodValue && !!this.periodYear;

                default: return false;
            }            
        }
    },    

    methods: {
        ...mapActions('sep/dynamictableaddrows', ['ok', 'cancel', 'updateDataSource', 'getSchema', 'importData', 'exportClassifier', 'addRowDataSource']),   
        validateForm() {
            this.$refs?.form?.validate();    
        },
        localized(val) {
            if (val == null)
                return val;
            if (typeof val === 'string') 
                return val;            
            else if (val[this.$i18n.locale] !== undefined)            
                return val[this.$i18n.locale];

            return null;
        },
        eval(strCode) {
            return eval(strCode);
        },
        async importClassifier() {
            try {
                let { dataFile } = await this.$refs.importClassifierDlg.open();
                this.importData({ dataFile });
            }
            catch (ex){
                if (ex.message != "Cancelled")
                    this._vm.$notify.alert(ex.message);
            }
        },
        calculate(tddata, trKey, tdKey) {            
            //console.log(tddata, sectionKey, trKey, tdKey);
            //onsole.log('calculate', trigger);
            switch(tddata)
            {
                case "this.columnSumm":
                    {
                        return this.dataSource.rows.reduce((a, v) => {

                            if (v.readonly)
                                return a;

                            let value = parseFloat(v.data[tdKey]);

                            if (!isNaN(value))                            
                                a += value;                            

                            return a;
                        }, 0.0);
                    } 

                // case "this.rowSumm": 
                // {
                //     return this.dataSource.sections[sectionKey].rows[trKey].data.reduce((a, v, i) => {

                //         //TODO use cache of getDataType
                //         if (this.getDataType(this.dataSource.sections[sectionKey], i))
                //         {
                //             let value = parseInt(v);

                //                 if (!isNaN(value))                            
                //                     a += value;  
                //         }

                //         return a;
                //     }, 0);
                // }
            }

            return null;
        },
        getHeadTRData() {
            let data = [];
            let hasNextLevel = true;
            let items = this.dataSource.cols;
            let level = 0;            
            let deepLevel = this.getDeepLevel(items);

            while(hasNextLevel) {
                level++;

                let result = items.reduce((acc, item) => {
                    acc.push({title: item.title, rowspan: (!Array.isArray(item.items) || item.items?.length == 0) && deepLevel - level + 1 > 1 ? deepLevel - level + 1 : null , colspan: this.getColspan(item)});
                    return acc;
                }, []);

                data.push(result);

                items = items.reduce((acc, item) => {
                    if (Array.isArray(item.items) && item.items?.length > 0)
                        item.items.forEach(i => acc.push(i));

                    return acc;
                }, []);

                hasNextLevel = items.length > 0;
            }

            return data;
        },
        getColspan(v){
            let result =  v.items?.length > 0 
            ? this.getWidthLevel(v.items)
            : null;            

            return result;
        },
        getDeepLevel(data) {
            let result = 0;
            let hasNextLevel = true;
            let items = data

            while(hasNextLevel) {
                result++;
                items = items.reduce((acc, item) => {
                    if (item.items?.length > 0)
                        item.items.forEach(i => acc.push(i));
                    return acc;
                }, []);

                hasNextLevel = items.length > 0;
            } 
            
            return result;
        },
        getWidthLevel(data) {
            let result = data.filter(i => !Array.isArray(i.items) || i.items.length == 0).length;
            let hasNextLevel = true;
            let items = data

            while(hasNextLevel) {
                items = items.reduce((acc, item) => {
                        item.items?.forEach(i => acc.push(i));
                    return acc;
                }, []);

                hasNextLevel = items.length > 0;
                
                result += items.filter(i => !Array.isArray(i.items) || i.items.length == 0).length
            } 
            
            return result;
        },
        getDataType(key) {
            let items = this.dataSource.cols;
            let result = items.filter(i => !Array.isArray(i.items) || i.items.length == 0);
            let hasNextLevel = true;

            while(hasNextLevel) {
                items = items.reduce((acc, item) => {
                        item.items?.forEach(i => acc.push(i));
                    return acc;
                }, []);

                hasNextLevel = items.length > 0;
                
                items.filter(i => !Array.isArray(i.items) || i.items.length == 0).forEach(i => result.push(i));
            } 
            
            return result[key]?.type;
        },
        updateCalculatedCells() {
            this.calculatedCellTrigger = this.$moment().valueOf();
        },
        onToolbarClick() {
            console.log('onToolbarClick');
        },
        handle(e) {
            this.dateMenuVisible = false
            this.$emit('input', e);
        },
        blockMinus(e) {
            if (e.key === '-' || e.keyCode === 45) {
            e.preventDefault();
            }
        },
        blockPasteWithMinus(e) {
            const pasted = (e.clipboardData || window.clipboardData).getData('text');
            if (pasted.includes('-')) {
            e.preventDefault();
            }
        },
        addRow() {
            this.addRowDataSource( { data: [null, null, null], id: 15 });
        }, 
        getValue(tdKey, e) {
            return this.getDataType(tdKey) == 'number' ? parseFloat(e) : e;
        }
    },

    mounted() {
        this.getSchema(this.$route.params.id);
    },

    updated() {
        // this.$nextTick(function () {
        //     // if (this.isVisible)
        //     //     this.validateForm();
        //     //console.log('updated');
        // });   
        //console.log('updated');
        //this.getData();
    },

    watch: {
        // periodObject: {
        //     handler: function(newValue) {
        //         console.log('periodObject', newValue);
        //     },
        //     immediate: true
        // }
    }
}
</script>